import { Component, Input } from '@angular/core';

interface Operative {
  img: string;
  title: string;
  handler: string;
}

@Component({
  selector: 'mapfre-top-navigation',
  templateUrl: './top-navigation.component.html',
  styleUrls: ['./top-navigation.component.scss']
})
export class TopNavigationComponent {
  @Input() data: Operative[];

  constructor() {}
}
